const INSERE_BACKLOG_MACROPROCESSOS = (state, payload) => {
  state.macroprocessos = payload
}

const LOADING = (state, payload) => {
  state.loading = payload
}

const INSERE_BACKLOG_TAREFAS = (state, payload) => {
  state.items = payload
}

const INSERE_TAREFAS = (state, payload) => {
  state.tarefas = payload
}

const INSERE_BACKLOG_INTERRUPCOES = (state, payload) => {
  state.interrupcoes = payload
}

const INSERE_BACKLOG_TAREFAS_PAINEL_ALARMES = (state, payload) => {
  state.painelAlarmes.box = payload
}

const INSERE_BACKLOG_DESATIVACAO_MACROPROCESSOS = (state, payload) => {
  state.itemsMacroprocessoDesativacao = payload
}

const INSERE_BACKLOG_DESATIVACAO_TAREFAS = (state, payload) => {
  state.itemsDesativacao = payload
}

const INSERE_BACKLOG_HEADER_BACKLOG = (state, payload) => {
    state.headerBacklog = payload
}

const INSERE_DETALHES_PROCESSO_BACKLOG = (state, payload) => {
  state.detalhesProcessoBacklog = payload
}

const LOADING_DETALHES_PROCESSO_BACKLOG = (state, payload) => {
  state.loadingDetalhesProcesso = payload
}

const LIMPAR_DETALHES_PROCESSO_BACKLOG = (state) => {
  state.detalhesProcessoBacklog = null
}

const INSERE_FILTROS_PAINEL_BACKLOG = (state, payload) => {
  state.filtrosPainelBacklog = payload
}

export {
  INSERE_BACKLOG_MACROPROCESSOS,
  LOADING,
  INSERE_BACKLOG_TAREFAS,
  INSERE_BACKLOG_INTERRUPCOES,
  INSERE_TAREFAS,
  INSERE_BACKLOG_TAREFAS_PAINEL_ALARMES,
  INSERE_BACKLOG_DESATIVACAO_MACROPROCESSOS,
  INSERE_BACKLOG_DESATIVACAO_TAREFAS,
  INSERE_BACKLOG_HEADER_BACKLOG,
  INSERE_DETALHES_PROCESSO_BACKLOG,
  LOADING_DETALHES_PROCESSO_BACKLOG,
  LIMPAR_DETALHES_PROCESSO_BACKLOG,
  INSERE_FILTROS_PAINEL_BACKLOG,
}